import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import React from "react";
import { Button, Divider, Typography, IconButton, Icon, Accordion, AccordionSummary, AccordionDetails, makeStyles, RaiseColors, Dialog, DialogActions, DialogTitle, DialogContent } from "componentLibrary";
import { accordionClasses } from "@mui/material/Accordion";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    dialog: {
      maxWidth: 520
    },
    dialogDivider: {
      borderTop: "1px solid ".concat(RaiseColors.gray100),
      borderBottom: "1px solid ".concat(RaiseColors.gray100)
    },
    titleBar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "16px 36px"
    },
    actionBar: {
      display: "flex",
      justifyContent: "end",
      alignItems: "center",
      padding: "16px 36px"
    },
    accordionRoot: _defineProperty({
      borderBottom: "1px solid ".concat(RaiseColors.gray100),
      "&:before": {
        display: "none"
      }
    }, "& .".concat(accordionClasses.expanded), {
      margin: 0
    }),
    nonExapndableContainer: {
      padding: "24px 32px",
      display: "flex",
      flexDirection: "column"
    },
    accordionSummaryRoot: {
      padding: "24px 32px"
    },
    accordionSummaryContent: _defineProperty({
      margin: 0
    }, "& .".concat(accordionClasses.expanded), {
      margin: 0
    }),
    accordionDetailsRoot: {
      padding: "0px 32px 24px"
    },
    // Gets rid of default MUI Accodrdion styles
    expandIcon: {
      padding: 0,
      margin: 0
    },
    expanded: {},
    appliedFilters: {
      padding: "16px 36px",
      display: "flex",
      width: "100%",
      alignItems: "center",
      justifyContent: "space-between"
    }
  };
});
var FiltersModal = function FiltersModal(_ref) {
  var filters = _ref.filters,
    numAppliedFilters = _ref.numAppliedFilters,
    onClearAllClick = _ref.onClearAllClick,
    open = _ref.open,
    onApply = _ref.onApply,
    onClose = _ref.onClose,
    potentialResults = _ref.potentialResults;
  var classes = useStyles();
  var potentialResultsValue = potentialResults && potentialResults > 1000 ? "1000+" : potentialResults;
  var potentialResultsText = potentialResultsValue ? "Showing ".concat(potentialResultsValue, " results") : "No Results Match Search";
  return /*#__PURE__*/_jsxs(Dialog, {
    open: open,
    onClose: onClose,
    scroll: "paper",
    maxWidth: "md",
    children: [/*#__PURE__*/_jsxs(DialogTitle, {
      style: {
        padding: 0
      },
      children: [/*#__PURE__*/_jsxs("div", {
        className: classes.titleBar,
        "data-testid": "filters-modal",
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h3",
          weight: "semibold",
          color: RaiseColors.black,
          children: "Filters"
        }), /*#__PURE__*/_jsx(IconButton, {
          size: "large",
          onClick: onClose,
          "data-testid": "filters-close-btn",
          children: /*#__PURE__*/_jsx(Icon, {
            className: "fal fa-times",
            fontSize: 24,
            style: {
              padding: 0
            }
          })
        })]
      }), numAppliedFilters > 0 && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs("div", {
          className: classes.appliedFilters,
          children: [/*#__PURE__*/_jsxs(Typography, {
            weight: "semibold",
            children: [numAppliedFilters, " Applied filters"]
          }), /*#__PURE__*/_jsx(Button, {
            variant: "textButton",
            onClick: onClearAllClick,
            children: "Clear All"
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx(DialogContent, {
      classes: {
        dividers: classes.dialogDivider
      },
      dividers: true,
      style: {
        padding: 0
      },
      children: _mapInstanceProperty(filters).call(filters, function (filter, index) {
        return /*#__PURE__*/_jsx(FilterAccordion, {
          filter: filter
        }, index);
      })
    }), /*#__PURE__*/_jsx(DialogActions, {
      className: classes.actionBar,
      children: /*#__PURE__*/_jsx(Button, {
        variant: "primaryButton",
        onClick: onApply,
        "data-testid": "filter-modal-apply-btn",
        children: potentialResultsText
      })
    })]
  });
};
export default FiltersModal;
var FilterAccordion = function FilterAccordion(_ref2) {
  var _filter$defaultExpand;
  var filter = _filterInstanceProperty(_ref2),
    trackExpanded = _ref2.trackExpanded;
  var classes = useStyles();
  var _React$useState = React.useState((_filter$defaultExpand = filter.defaultExpanded) !== null && _filter$defaultExpand !== void 0 ? _filter$defaultExpand : false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isExpanded = _React$useState2[0],
    setIsExpanded = _React$useState2[1];
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "filter-accordion",
    children: /*#__PURE__*/_jsxs(Accordion, {
      square: true,
      classes: {
        root: classes.accordionRoot,
        expanded: classes.expanded
      },
      expanded: isExpanded,
      onChange: function onChange(_, expanded) {
        setIsExpanded(expanded);
      },
      children: [/*#__PURE__*/_jsx(AccordionSummary, {
        classes: {
          root: classes.accordionSummaryRoot,
          content: classes.accordionSummaryContent,
          expanded: classes.expanded,
          expandIcon: classes.expandIcon
        },
        expandIcon: /*#__PURE__*/_jsx(Icon, {
          className: "far fa-chevron-up",
          color: RaiseColors.destructive500,
          fontSize: 16
        }),
        children: /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph_medium",
          weight: "semibold",
          color: RaiseColors.black,
          children: filter.title
        })
      }), /*#__PURE__*/_jsx(AccordionDetails, {
        classes: {
          root: classes.accordionDetailsRoot
        },
        children: filter.Component
      })]
    })
  });
};